// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"5a33a3a8","137":"45373087","233":"a328b253","241":"77842d2a","481":"285824c6","518":"65b9fd08","657":"2367b3af","658":"de4ee0d0","670":"ebaec4fe","741":"f5a579af","822":"30ad03a0","858":"1ba7f74e","865":"7c1a9dd8","900":"f1c54686"}[chunkId] + ".chunk.js";
};